import { z } from 'zod';

import { articleCategorySchema } from './article.js';
import { isoDateTimeSchema } from './common.js';
import { setorSlugSchema } from './project.js';

/**
 * Validador de cor hex (`#RGB`, `#RRGGBB` ou `#RRGGBBAA`).
 * Aceita lowercase ou uppercase.
 */
export const hexColorSchema = z
  .string()
  .regex(/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/, {
    message: 'Cor deve ser hex (ex.: #00408F).',
  });

/**
 * Categoria editorial. Slug é fixo (validado pelo articleCategorySchema do
 * blog). Demais campos são editáveis pelo admin.
 */
export const categorySchema = z.object({
  slug: articleCategorySchema,
  nome: z.string().min(1).max(120),
  descricao: z.string().nullable(),
  cor: hexColorSchema,
  ordem: z.number().int(),
  visivel: z.boolean(),
  criadoEm: isoDateTimeSchema,
  atualizadoEm: isoDateTimeSchema,
});
export type Category = z.infer<typeof categorySchema>;

/** Campos editáveis pelo admin. Slug não muda. */
export const updateCategoryInputSchema = z.object({
  nome: z.string().min(1).max(120).optional(),
  descricao: z.string().max(500).nullable().optional(),
  cor: hexColorSchema.optional(),
  ordem: z.number().int().min(0).max(9999).optional(),
  visivel: z.boolean().optional(),
});
export type UpdateCategoryInput = z.infer<typeof updateCategoryInputSchema>;

/**
 * Setor de atuação. Análogo à Category, mas com o enum de setores.
 */
export const sectorSchema = z.object({
  slug: setorSlugSchema,
  nome: z.string().min(1).max(120),
  descricao: z.string().nullable(),
  cor: hexColorSchema,
  ordem: z.number().int(),
  visivel: z.boolean(),
  criadoEm: isoDateTimeSchema,
  atualizadoEm: isoDateTimeSchema,
});
export type Sector = z.infer<typeof sectorSchema>;

export const updateSectorInputSchema = z.object({
  nome: z.string().min(1).max(120).optional(),
  descricao: z.string().max(500).nullable().optional(),
  cor: hexColorSchema.optional(),
  ordem: z.number().int().min(0).max(9999).optional(),
  visivel: z.boolean().optional(),
});
export type UpdateSectorInput = z.infer<typeof updateSectorInputSchema>;
